<template>
	<div class="row">
		<div class="col-12">
			<div class="wrapper-headlines">
				<div class="row justify-content-center">
					<div class="col-md-12 col-lg-auto">
						<h1 class="d-inline-block">{{ $t(title) }}</h1>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Title",
	props: {
		title: {
			type: String,
			default: 'Title/$TITLE'
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Generals/Title.vue